/**
 * spm相关操作
 * @see https://cmp.alibaba-inc.com/log/info.htm?spm=a1z71.7905536/2392.outline.1.5017a1eKo4wvC&type=2392&id=10
 */

/**
 * 点击事件捕获(确保在冒泡之前设置)，
 * 全局注入target便于获取spm，以实现不手动传入。
 */
/* eslint-disable no-param-reassign */

document.addEventListener(
  'click',
  e => {
    window.__tpp_click_target = e.target;
  },
  true
);

export type GetSpmAB = () => [string, string];

/**
 * 获取当前页面spmAB位，先尝试从`window.goldlog.spm_ab`上取，取不到再从meta和DOM节点上取
 */
export const getSpmAB: GetSpmAB = () => {
  let spmArr: string[] = [];
  const goldlogAB: string[] = (window.goldlog || {}).spm_ab || [];

  // aplus脚本已加载(异步)
  if (goldlogAB.length === 2) {
    spmArr = goldlogAB;
  } else {
    // 如：1. <meta name="data-spm" content="a1z2r">
    // 2. <meta name="spm-id" content="a2o71">、<meta name="spm-id" content="a21b3.25509381">
    const meta =
      document.querySelector('meta[name="data-spm"]') ||
      document.querySelector('meta[name="spm-id"]');
    if (meta) {
      spmArr = (meta.getAttribute('content') || '').split('.');
      // 没有B位
      if (!spmArr[1]) {
        spmArr[1] =
          document.documentElement.getAttribute('data-spmb') ||
          document?.body?.getAttribute('data-spm') ||
          '';
      }
    }
  }

  // 兜底补偿AB位
  if (!spmArr[0]) {
    spmArr[0] = 'spmA';
  }
  if (!spmArr[1]) {
    spmArr[1] = 'spmB';
  }

  return spmArr as [string, string];
};

/**
 * 获取当前页面spm
 * @param separator 分隔符，默认：.
 * @param spmC spmC位(存在则忽略dom)
 * @param spmD spmD位
 * @param dom dom元素|Zepto对象
 * @returns spm字符串，默认：spmA.spmB
 */
export function getSpm(
  { separator = '.', spmC = '', spmD = 'd0', dom } = {} as any
) {
  const spmArr = [...getSpmAB()];

  // 指定了C位
  if (spmC) {
    spmArr.push(spmC);
    spmArr.push(spmD);
    return spmArr.join(separator);
  }

  if (window.g_SPM) {
    // 使用dom元素或Zepto对象生成spm
    if (dom) {
      // Zepto对象转dom
      if (dom.length) {
        dom = dom[0];
      }
    } else if (window.__tpp_click_target && window.__tpp_click_target.closest) {
      // 查找事件目标最近含有data-spm的祖先元素(含自己)
      dom = window.__tpp_click_target.closest('[data-spm]');
    }
    if (!dom) {
      dom = document.head;
    }
    // 节点类型为元素
    if (dom.nodeType === 1) {
      const domC = dom.getAttribute('data-spm-c');
      const domD = dom.getAttribute('data-spm');
      if (domC && domD) return [...spmArr, domC, domD].join(separator);
      return window.g_SPM.spm(dom);
    }
  }

  // 继续生成spmA.B.unknown.D
  spmArr.push('unknown');
  spmArr.push(spmD);

  return spmArr.join(separator);
}

/**
 * 获取当前页面spmB
 */
export function getSpmB() {
  const spmAb = getSpmAB();
  return spmAb[1] || '';
}
